import { settingsService } from "../_services";

const state = {
    settings:
    {
        Domains: [],
        Flows: {},
        PassIds:{},
        AnchorElementTypes: {},
        AnchorElementPositions: {},
        ExcludedStates: {}
    },
    iframeSettings:
    {
      Style: {},
      Name: "null",
      Domain: "null"
    },
    Flows: {},
    AnchorElementTypes: {},
    AnchorElementPositions: {},
    ExcludedStates: {},
    ValidFlows:[],
    BCSettingsList: [
        {
            Hash: "",
            BCAccessToken: "",
            SubscriberServiceFlowIDPreCheckout: null,
            SubscriberServiceFlowIDPostCheckout: null,
            SubscriberServiceFlowIDClearShop: null,
            OrderStatusUpdate: false,
            OrderComment: false,
            DisplayCondlFail: false,
            DisplayCustomerType: false,
            DisplayLicenseMap: false,
            PreCheckoutEnabled: false,
            Fee: {
                Enabled: false,
                Minimum: 0,
                Maximum: 0,
                Percent: 0,
                CountDuplicates: 0,
            },
            AnchorElementTypeID: null,
            AnchorElementValue: null,
            AnchorElementPositionID: null,
            ExcludedStates: null,
            ExcludedCustomerGroups: null,
            StatusGuard: false,
            AllowedStatuses: null,
            AutoCancel: false,
            PassStatusEnabled: false,
            PassStatusId: null,
            FailStatusEnabled: false,
            FailStatusId: null,
            PostOrderTriggerMode: 0,
            PostOrderTriggerStatuses: null,
            ClearShopEnabled: false,
            CacheCleared: null,
            AllowedDomain: null,
            LocationBarPromptText: null,
            LocationBarHeaderText: null,
            LocationBarExcludedText: null,
            PdpMessageSuccess: null,
            PdpMessageConditional: null,
            PdpMessageFflConsumer: null,
            PdpMessageFflB2bProvided: null,
            PdpMessageFflB2bNotProvided: null,
            PdpMessageCatalogError: null,
            PdpExcludedText: null,
            RestrictedPrefix: null,
            ScriptUUID: null
        }
    ],
    BCChannels: [],
    BCChannelsError: null,
    BCCustomerGroups: [],
    BCCustomerGroupsError: null,
    BCSettings: {
        Hash: "",
        BCAccessToken: "",
        SubscriberServiceFlowIDPreCheckout: null,
        SubscriberServiceFlowIDPostCheckout: null,
        SubscriberServiceFlowIDClearShop: null,
        OrderStatusUpdate: false,
        OrderComment: false,
        DisplayCondlFail: false,
        DisplayCustomerType: false,
        DisplayLicenseMap: false,
        PreCheckoutEnabled: false,
        Fee: {
            Enabled: false,
            Minimum: 0,
            Maximum: 0,
            Percent: 0,
            CountDuplicates: 0,
        },
        AnchorElementTypeID: null,
        AnchorElementValue: null,
        AnchorElementPositionID: null,
        ExcludedStates: null,
        ExcludedCustomerGroups: null,
        StatusGuard: false,
        AllowedStatuses: null,
        AutoCancel: false,
        PassStatusEnabled: false,
        PassStatusId: null,
        FailStatusEnabled: false,
        FailStatusId: null,
        PostOrderTriggerMode: 0,
        PostOrderTriggerStatuses: null,
        ClearShopEnabled: false,
        CacheCleared: null,
        AllowedDomain: null,
        LocationBarPromptText: null,
        LocationBarHeaderText: null,
        LocationBarExcludedText: null,
        PdpMessageSuccess: null,
        PdpMessageConditional: null,
        PdpMessageFflConsumer: null,
        PdpMessageFflB2bProvided: null,
        PdpMessageFflB2bNotProvided: null,
        PdpMessageCatalogError: null,
        PdpExcludedText: null,
        RestrictedPrefix: null,
        ScriptUUID: null
    },
    Profile: {},
    Script: null,
    Status: {
      getIframeSettingsURLLoading: null,
      getIframeSettingsLoading: null,
      updateIframeSettingsLoading: null,
      deleteIframeSettingsLoading: null,
      getOptionSettingsRequestLoading: null,
      addOptionRequestLoading: null,
      deleteOptionRequestLoading: null,
      getSubFlowsRequestLoading: null,
      updateBigCommerceRequestLoading: null,
      getProfileSettingsRequestLoading: null,
      updateProfileSettingsRequestLoading: null,
      getAnchorElementTypesRequestLoading: null,
      getAnchorElementPositionsRequestLoading: null,
      getExcludedStatesRequestLoading: null
    },
    Error: {}
};

const actions = {
  getIframeSettings({ dispatch, commit })
  {
    commit("getIframeSettingsRequest");
    
    settingsService.getIframeSettings().then(
      response => {
        commit("getIframeSettingsSuccess", response);
      },
      error => {
        commit("getIframeSettingsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  updateIframeSettings({ dispatch, commit }, newSetting)
  {
    commit("updateIframeSettingsRequest");
    
    settingsService.updateIframeSettings(newSetting).then(
      response => {
        commit("updateIframeSettingsSuccess");
        dispatch("getIframeSettings");
      },
      error => {
        commit("updateIframeSettingsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  deleteIframeSettings({ dispatch, commit }, newSetting)
  {
    commit("deleteIframeSettingsRequest");
    
    settingsService.deleteIframeSettings(newSetting).then(
      response => {
        commit("deleteIframeSettingsSuccess");
        dispatch("getIframeSettings");
      },
      error => {
        commit("deleteIframeSettingsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  
  getSubFlows({ dispatch, commit })
  {
    
    commit("getSubFlowsRequest");
    //commit("getOptionSettingsRequest");
    
    settingsService.getSubFlows().then(
      response => {
        commit("getSubFlowsSuccess", response);
      },
      error => {
        commit("getSubFlowsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  getAnchorElementTypes({ dispatch, commit })
  {
    
    commit("getAnchorElementTypesRequest");
    
    settingsService.getAnchorElementTypes().then(
      response => {
        commit("getAnchorElementTypesSuccess", response);
      },
      error => {
        commit("getAnchorElementTypesFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  getAnchorElementPositions({ dispatch, commit })
  {
    
    commit("getAnchorElementPositionsRequest");
    
    settingsService.getAnchorElementPositions().then(
      response => {
        commit("getAnchorElementPositionsSuccess", response);
      },
      error => {
        commit("getAnchorElementPositionsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  getExcludedStates({ dispatch, commit })
  {
    
    commit("getExcludedStatesRequest");
    
    settingsService.getExcludedStates().then(
      response => {
        commit("getExcludedStatesSuccess", response);
      },
      error => {
        commit("getExcludedStatesFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  getOptionSettings({ dispatch, commit })
  {
    commit("getOptionSettingsRequest");
    
    settingsService.getOptionSettings().then(
      response => {
        commit("getOptionSettingsSuccess", response);
      },
      error => {
        commit("getOptionSettingsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  addOption({ dispatch, commit }, newSetting)
  {
    commit("addOptionRequest");
    
    settingsService.addOption(newSetting).then(
      response => {
        commit("addOptionSuccess");
        dispatch("getOptionSettings");
      },
      error => {
        commit("addOptionFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  deleteOption({ dispatch, commit }, newSetting)
  {
    commit("deleteOptionRequest");
    
    settingsService.deleteOption(newSetting).then(
      response => {
        commit("deleteOptionSuccess");
        dispatch("getOptionSettings");
      },
      error => {
        commit("deleteOptionFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  //BigCommerce
  async addBigCommerce({ dispatch, commit }, newSetting)
  {
    commit("addBigCommerceRequest");
    
    await settingsService.addBigCommerce(newSetting).then(
      response => {
        commit("addBigCommerceSuccess", response);
      },
      error => {
        commit("addBigCommerceFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async deleteBigCommerce({ dispatch, commit }, newSetting)
  {
    commit("deleteBigCommerceRequest");
    
    await settingsService.deleteBigCommerce(newSetting).then(
      response => {
        commit("deleteBigCommerceSuccess", response);
      },
      error => {
        commit("deleteBigCommerceFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async updateBigCommerce({ dispatch, commit }, newSetting)
  {
    commit("updateBigCommerceRequest");
    
    await settingsService.updateBigCommerce(newSetting).then(
      response => {
        commit("updateBigCommerceSuccess", response);
      },
      error => {
        commit("updateBigCommerceFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getAllBigCommerce({ dispatch, commit })
  {
    commit("getAllBigCommerceRequest");
    
    await settingsService.getAllBigCommerce().then(
      response => {
        commit("getAllBigCommerceSuccess", response);
      },
      error => {
        commit("getAllBigCommerceFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async getBigCommerceChannels({ commit }, { hash, token })
  {
      commit("getBigCommerceChannelsRequest");

      await settingsService.getBigCommerceChannels(hash, token).then(
          response => {
              commit("getBigCommerceChannelsSuccess", response);
          },
          error => {
              commit("getBigCommerceChannelsFailure", error);
          }
      );
  },
  async getBigCommerceCustomerGroups({ commit }, { hash, token })
  {
      commit("getBigCommerceCustomerGroupsRequest");

      await settingsService.getBigCommerceCustomerGroups(hash, token).then(
          response => {
              commit("getBigCommerceCustomerGroupsSuccess", response);
          },
          error => {
              commit("getBigCommerceCustomerGroupsFailure", error);
          }
      );
  },

    //profile
    async getProfileSettings({ dispatch, commit })
    {
        commit("getProfileSettingsRequest");
        
        await settingsService.getProfileSettings().then(
        response => {
            commit("getProfileSettingsSuccess", response);
        },
        error => {
            commit("getProfileSettingsFailure", error);
            dispatch("alert/error", error, { root: true });
        }
        );
    },

    async updateProfileSettings({ dispatch, commit }, settings)
    {
        commit("updateProfileSettingsRequest");
        
        await settingsService.updateProfileSettings(settings).then(
        response => {
            commit("updateProfileSettingsSuccess", response);
        },
        error => {
            commit("updateProfileSettingsFailure", error);
            dispatch("alert/error", error, { root: true });
        }
        );
    },

  //get settings by url
  getIframeSettingsByURL({ dispatch, commit }, url)
  {
    commit("getIframeSettingsURLRequest");
    
    settingsService.getIframeSettingsByURL(url).then(
      response => {
        commit("getIframeSettingsURLSuccess", response);
      },
      error => {
        commit("getIframeSettingsURLFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

    async getScript({ dispatch, commit }, ScriptData)
    {
        commit("getScriptRequest");
        
        await settingsService.getScript(ScriptData).then(
            response => {
                commit("getScriptSuccess", response);
            },
            error => {
                commit("getScriptFailure", error);
                dispatch("alert/error", error, { root: true });
            }
        );
    },
};

const mutations = 
{//CALLS
  //iframe
  getIframeSettingsRequest(state)
  {
    state.Status.getIframeSettingsLoading = true;
  },
  getIframeSettingsSuccess(state, response) 
  {
    state.settings.Domains = [];
    for(const record of response)
    {
      state.settings.Domains.push({Id: record.id, Name: record.name, Style: record.style, Url: record.domain, ServiceFlowID: record.serviceFlowID, CustomerServiceEmail: record.customerServiceEmail, CustomerServiceEmailFrom: record.customerServiceEmailFrom});
    }
    state.Status.getIframeSettingsLoading = false;
  },
  getIframeSettingsFailure(state, error) 
  {
    state.Status.getIframeSettingsLoading = false;
    state.Error = { error: error }
  },

  updateIframeSettingsRequest(state)
  {
    state.Status.updateIframeSettingsLoading = true;
  },
  updateIframeSettingsSuccess(state)
  {
    state.Status.updateIframeSettingsLoading = false;
  },
  updateIframeSettingsFailure(state, error)
  {
    state.Status.updateIframeSettingsLoading = false;
  },

  deleteIframeSettingsRequest(state)
  {
    state.Status.deleteIframeSettingsLoading = true;
  },
  deleteIframeSettingsSuccess(state)
  {
    state.Status.deleteIframeSettingsLoading = false;
  },
  deleteIframeSettingsFailure(state, error)
  {
    state.Status.deleteIframeSettingsLoading = false;
  },

  getSubFlowsRequest(state)
  {
    state.Status['getSubFlowsRequestLoading'] = true;
  },
  getSubFlowsSuccess(state, response)
  {
    state.Flows = {};
    for(const record of response)
    {
      state.Flows[record.id + ""] = {Id: record.id, Name: record.flowName, Description: record.description, PositionID: record.positionID};
    }
    state.Status['getSubFlowsRequestLoading'] = false;
  },
  getSubFlowsFailure(state)
  {
    state.Status['getSubFlowsRequestLoading'] = false;
  },

  getAnchorElementTypesRequest(state)
  {
    state.Status['getAnchorElementTypesRequestLoading'] = true;
  },
  getAnchorElementTypesSuccess(state, response)
  {
    state.AnchorElementTypes = {};
    for(const record of response)
    {
      state.AnchorElementTypes[record.id + ""] = {Id: record.id, Name: record.anchorElementType};
    }
    state.Status['getAnchorElementTypesRequestLoading'] = false;
  },
  getAnchorElementTypesFailure(state)
  {
    state.Status['getAnchorElementTypesRequestLoading'] = false;
  },

  getAnchorElementPositionsRequest(state)
  {
    state.Status['getAnchorElementPositionsRequestLoading'] = true;
  },
  getAnchorElementPositionsSuccess(state, response)
  {
    state.AnchorElementPositions = {};
    for(const record of response)
    {
      state.AnchorElementPositions[record.id + ""] = {Id: record.id, Name: record.anchorElementPosition};
    }
    state.Status['getAnchorElementPositionsRequestLoading'] = false;
  },
  getAnchorElementPositionsFailure(state)
  {
    state.Status['getAnchorElementPositionsRequestLoading'] = false;
  },

  getExcludedStatesRequest(state)
  {
    state.Status['getExcludedStatesRequestLoading'] = true;
  },
  getExcludedStatesSuccess(state, response)
  {
    state.ExcludedStates = response
    state.Status['getExcludedStatesRequestLoading'] = false;
  },
  getExcludedStatesFailure(state)
  {
    state.Status['getExcludedStatesRequestLoading'] = false;
  },

  getOptionSettingsRequest(state)
  {
    state.Status['getOptionSettingsRequestLoading'] = true;
  },
  getOptionSettingsSuccess(state, response)
  {
    state.settings.Flows = {};
    for(const flowId in response.flows)
    {
      const flow = response.flows[flowId];
      if(!state.settings.Flows[flow.id])
      state.settings.Flows[flow.id] = {ID: flow.id, Name: flow.name, Description: flow.description, FlowID: flow.flowId, Services: flow.services};
    }

    state.Status['getOptionSettingsRequestLoading'] = false;
  },
  getOptionSettingsFailure(state)
  {
    state.Status['getOptionSettingsRequestLoading'] = false;
  },

  addOptionRequest(state)
  {
    state.Status.addOptionRequestLoading = true;
  },
  addOptionSuccess(state)
  {
    state.Status.addOptionRequestLoading = false;
  },
  addOptionFailure(state)
  {
    state.Status.addOptionRequestLoading = false;
  },

  deleteOptionRequest(state)
  {
    state.Status.deleteOptionRequestLoading = true;
  },
  deleteOptionSuccess(state)
  {
    state.Status.deleteOptionRequestLoading = false;
  },
  deleteOptionFailure(state)
  {
    state.Status.deleteOptionRequestLoading = false;
  },

  //BigCommerce
  updateBigCommerceRequest(state)
  {
    state.Status.updateBigCommerceRequestLoading = true;
  },
  updateBigCommerceSuccess(state)
  {
    state.Status.updateBigCommerceRequestLoading = false;
  },
  updateBigCommerceFailure(state)
  {
    state.Status.updateBigCommerceRequestLoading = false;
  },

  addBigCommerceRequest(state)
  {
    state.Status.addBigCommerceRequestLoading = true;
  },
  addBigCommerceSuccess(state)
  {
    state.Status.addBigCommerceRequestLoading = false;
  },
  addBigCommerceFailure(state, error)
  {
    state.Status.addBigCommerceRequestLoading = false;
    throw new Error("Add Failed");
  },

  deleteBigCommerceRequest(state)
  {
    state.Status.deleteBigCommerceRequestLoading = true;
  },
  deleteBigCommerceSuccess(state)
  {
    state.Status.deleteBigCommerceRequestLoading = false;
  },
  deleteBigCommerceFailure(state)
  {
    state.Status.deleteBigCommerceRequestLoading = false;
  },

  getBigCommerceRequest(state)
  {
    state.Status.getBigCommerceRequestLoading = true;
  },
  getBigCommerceSuccess(state, response)
  {
    state.BCSettings.Hash = response.hash;
    state.BCSettings.BCAccessToken = response.bcAccessToken;
    state.BCSettings.SubscriberServiceFlowIDPreCheckout = response.subscriberServiceFlowIDPreCheckout;
    state.BCSettings.SubscriberServiceFlowIDPostCheckout = response.subscriberServiceFlowIDPostCheckout;
    state.BCSettings.SubscriberServiceFlowIDClearShop = response.subscriberServiceFlowIDClearShop;
    state.BCSettings.OrderStatusUpdate = response.orderStatusUpdate;
    state.BCSettings.OrderComment = response.orderComment;
    state.BCSettings.PreCheckoutEnabled = response.preCheckoutEnabled;
    state.BCSettings.DisplayCondlFail = response.displayCondlFail;
    state.BCSettings.DisplayCustomerType = response.displayCustomerType;
    state.BCSettings.Fee.Enabled = response.fee.enabled;
    state.BCSettings.Fee.Minimum = response.fee.minimum;
    state.BCSettings.Fee.Maximum = response.fee.maximum;
    state.BCSettings.Fee.Percent = response.fee.percent;
    state.BCSettings.Fee.CountDuplicates = response.fee.countDuplicates;
    state.BCSettings.AnchorElementTypeID = response.anchorElementTypeID;
    state.BCSettings.AnchorElementValue = response.anchorElementValue;
    state.BCSettings.AnchorElementPositionID = response.anchorElementPositionID;
    state.BCSettings.AnchorElementValue = response.anchorElementValue;
    state.BCSettings.AnchorElementPositionID = response.anchorElementPositionID;
    state.BCSettings.ExcludedStates = response.excludedStates;
    state.BCSettings.ExcludedCustomerGroups = response.excludedCustomerGroups;
    state.BCSettings.StatusGuard = response.statusGuard;
    state.BCSettings.AllowedStatuses = response.allowedStatuses;
    state.BCSettings.AutoCancel = response.autoCancel;
    state.BCSettings.PassStatusEnabled = response.passStatusEnabled;
    state.BCSettings.PassStatusId = response.passStatusId;
    state.BCSettings.FailStatusEnabled = response.failStatusEnabled;
    state.BCSettings.FailStatusId = response.failStatusId;
    state.BCSettings.PostOrderTriggerMode = response.postOrderTriggerMode;
    state.BCSettings.PostOrderTriggerStatuses = response.postOrderTriggerStatuses;
    state.BCSettings.ClearShopEnabled = response.clearShopEnabled;
    state.BCSettings.CacheCleared = response.cacheCleared;
    state.BCSettings.AllowedDomain = response.allowedDomain;
    state.BCSettings.LocationBarPromptText = response.locationBarPromptText;
    state.BCSettings.LocationBarHeaderText = response.locationBarHeaderText;
    state.BCSettings.LocationBarExcludedText = response.locationBarExcludedText;
    state.BCSettings.PdpMessageSuccess = response.pdpMessageSuccess;
    state.BCSettings.PdpMessageConditional = response.pdpMessageConditional;
    state.BCSettings.PdpMessageFflConsumer = response.pdpMessageFflConsumer;
    state.BCSettings.PdpMessageFflB2bProvided = response.pdpMessageFflB2bProvided;
    state.BCSettings.PdpMessageFflB2bNotProvided = response.pdpMessageFflB2bNotProvided;
    state.BCSettings.PdpMessageCatalogError = response.pdpMessageCatalogError;
    state.BCSettings.PdpExcludedText = response.pdpExcludedText;
    state.BCSettings.RestrictedPrefix = response.restrictedPrefix;
    state.Status.getBigCommerceRequestLoading = false;
  },
  getBigCommerceFailure(state)
  {
    state.Status.getBigCommerceRequestLoading = false;
  },

  getAllBigCommerceRequest(state)
  {
    state.Status.getAllBigCommerceRequestLoading = true;
  },
  getAllBigCommerceSuccess(state, response)
  {
    state.BCSettingsList = [];
    for(const row of response)
    {
        const newEntry = {}
        newEntry.ID = row.id;
        newEntry.Hash = row.hash;
        newEntry.StoreName = row.storeName;
        newEntry.BCAccessToken = row.bcAccessToken;
        newEntry.StoreChannelID = row.storeChannelID;
        newEntry.SubscriberServiceFlowIDPreCheckout = row.subscriberServiceFlowIDPreCheckout;
        newEntry.SubscriberServiceFlowIDPostCheckout = row.subscriberServiceFlowIDPostCheckout;
        newEntry.SubscriberServiceFlowIDClearShop = row.subscriberServiceFlowIDClearShop;
        newEntry.OrderStatusUpdate = row.orderStatusUpdate;
        newEntry.OrderComment = row.orderComment;
        newEntry.PreCheckoutEnabled = row.preCheckoutEnabled;
        newEntry.DisplayCondlFail = row.displayCondlFail;
        newEntry.DisplayCustomerType = row.displayCustomerType;
        newEntry.DisplayLicenseMap = row.displayLicenseMap;
        newEntry.Fee = {};
        newEntry.Fee.Enabled = row.fee.enabled;
        newEntry.Fee.Minimum = row.fee.minimum;
        newEntry.Fee.Maximum = row.fee.maximum;
        newEntry.Fee.Percent = row.fee.percent;
        newEntry.Fee.CountDuplicates = row.fee.countDuplicates;
        newEntry.AnchorElementTypeID = row.anchorElementTypeID;
        newEntry.AnchorElementValue = row.anchorElementValue;
        newEntry.AnchorElementPositionID = row.anchorElementPositionID;
        newEntry.ScriptUUID = row.scriptUUID;
        newEntry.ExcludedStates = row.excludedStates;
        newEntry.ExcludedCustomerGroups = row.excludedCustomerGroups;
        newEntry.StatusGuard = row.statusGuard;
        newEntry.AllowedStatuses = row.allowedStatuses;
        newEntry.AutoCancel = row.autoCancel;
        newEntry.PassStatusEnabled = row.passStatusEnabled;
        newEntry.PassStatusId = row.passStatusId;
        newEntry.FailStatusEnabled = row.failStatusEnabled;
        newEntry.FailStatusId = row.failStatusId;
        newEntry.PostOrderTriggerMode = row.postOrderTriggerMode;
        newEntry.PostOrderTriggerStatuses = row.postOrderTriggerStatuses;
        newEntry.ClearShopEnabled = row.clearShopEnabled;
        newEntry.CacheCleared = row.cacheCleared;
        newEntry.AllowedDomain = row.allowedDomain;
        newEntry.LocationBarPromptText = row.locationBarPromptText;
        newEntry.LocationBarHeaderText = row.locationBarHeaderText;
        newEntry.LocationBarExcludedText = row.locationBarExcludedText;
        newEntry.PdpMessageSuccess = row.pdpMessageSuccess;
        newEntry.PdpMessageConditional = row.pdpMessageConditional;
        newEntry.PdpMessageFflConsumer = row.pdpMessageFflConsumer;
        newEntry.PdpMessageFflB2bProvided = row.pdpMessageFflB2bProvided;
        newEntry.PdpMessageFflB2bNotProvided = row.pdpMessageFflB2bNotProvided;
        newEntry.PdpMessageCatalogError = row.pdpMessageCatalogError;
        newEntry.PdpExcludedText = row.pdpExcludedText;
        newEntry.RestrictedPrefix = row.restrictedPrefix;
        state.BCSettingsList.push(newEntry);
    }
    state.Status.getAllBigCommerceRequestLoading = false;
  },
  getAllBigCommerceFailure(state)
  {
    state.Status.getAllBigCommerceRequestLoading = false;
  },
  getBigCommerceChannelsRequest(state)
  {
      state.BCChannels = [];
      state.BCChannelsError = null;
  },
  getBigCommerceChannelsSuccess(state, response)
  {
      if (response.success)
      {
          state.BCChannels = response.channels;
          state.BCChannelsError = null;
      }
      else
      {
          state.BCChannels = [];
          state.BCChannelsError = response.message;
      }
  },
  getBigCommerceChannelsFailure(state, error)
  {
      state.BCChannels = [];
      state.BCChannelsError = "Unable to retrieve channels.";
  },
  getBigCommerceCustomerGroupsRequest(state)
  {
      state.BCCustomerGroups = [];
      state.BCCustomerGroupsError = null;
  },
  getBigCommerceCustomerGroupsSuccess(state, response)
  {
      if (response.success)
      {
          state.BCCustomerGroups = response.customerGroups;
          state.BCCustomerGroupsError = null;
      }
      else
      {
          state.BCCustomerGroups = [];
          state.BCCustomerGroupsError = response.message;
      }
  },
  getBigCommerceCustomerGroupsFailure(state, error)
  {
      state.BCCustomerGroups = [];
      state.BCCustomerGroupsError = "Unable to retrieve customer groups.";
  },

  //profile
  getProfileSettingsRequest(state)
  {
    state.Status.getProfileSettingsRequestLoading = true;
  },
  getProfileSettingsSuccess(state, response)
  {
    state.Profile = response;
    state.Status.getProfileSettingsRequestLoading = false;
  },
  getProfileSettingsFailure(state, error)
  {
    state.Status.getProfileSettingsRequestLoading = false;
    console.log(error)
  },

  updateProfileSettingsRequest(state)
  {
    state.Status.updateProfileSettingsRequestLoading = true;
  },
  updateProfileSettingsSuccess(state, response)
  {
    state.Status.updateProfileSettingsRequestLoading = false;
  },
  updateProfileSettingsFailure(state, error)
  {
    state.Status.updateProfileSettingsRequestLoading = false;
    console.log(error)
  },

  //get settings for URL
  getIframeSettingsURLRequest(state)
  {
    state.Status.getIframeSettingsURLLoading = true;
  },
  getIframeSettingsURLSuccess(state, response) 
  {
    state.iframeSettings = {Style: response.style, Name: response.name, Domain: response.domain};
    state.Status.getIframeSettingsURLLoading = false;
  },
  getIframeSettingsURLFailure(state, error) 
  {
    state.Status.getIframeSettingsURLLoading = false;
    console.log(error);
    state.Error = { error: error }
  },

  getScriptRequest(state)
  {
    state.Status.getSubFlowsRequestLoading = true;
  },
  getScriptSuccess(state, response)
  {
    state.Script = response.script;
    state.Status.getSubFlowsRequestLoading = false;
  },
  getScriptFailure(state)
  {
    state.Status.getSubFlowsRequestLoading = false;
  },
};

export const settings = 
{
  namespaced: true,
  state,
  actions,
  mutations
};